export default class InputRange {
    constructor(element) {
        this.rangeInput = element.querySelectorAll('.range-input input')
        this.priceInput = element.querySelectorAll('.price-input input')
        this.range = element.querySelector('.slider .progress')
        this.priceGap = 5;
        this.rangeLabel = element.querySelectorAll('.range-input .range-value')

        this.priceInput.forEach(input => {
            input.addEventListener('input', e => {
                let minPrice = parseFloat(this.priceInput[0].value)
                let maxPrice = parseFloat(this.priceInput[1].value)

                if ((maxPrice - minPrice >= this.priceGap) && maxPrice <= this.rangeInput[1].max) {
                    if (e.target.className === 'input-min') {
                        this.rangeInput[0].value = minPrice
                        this.range.style.left = ((minPrice / this.rangeInput[0].max) * 100) + "%"
                        this.rangeLabel[0].innerHTML = this.priceInput[0].value + '€'
                    } else {
                        this.rangeInput[1].value = maxPrice
                        this.range.style.right = 100 - (maxPrice / this.rangeInput[1].max) * 100 + '%'
                        this.rangeLabel[1].innerHTML = this.priceInput[1].value + '€'
                    }
                }
            })

            // Force dispatch event to prevent inconsistent display
            input.dispatchEvent(new Event('input'))
        })

        this.rangeInput.forEach(input => {
            input.addEventListener('input', e => {
                let minVal = parseFloat(this.rangeInput[0].value)
                let maxVal = parseFloat(this.rangeInput[1].value)

                if ((maxVal - minVal) < this.priceGap) {
                    if (e.target.className === 'range-min') {
                        this.rangeInput[0].value = maxVal - this.priceGap
                    } else {
                        this.rangeInput[1].value = minVal + this.priceGap
                    }
                } else {
                    this.priceInput[0].value = minVal
                    this.priceInput[1].value = maxVal
                }

                this.range.style.left = ((minVal / this.rangeInput[0].max) * 100) + '%'
                this.range.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + '%'

                this.rangeLabel[0].innerHTML = this.priceInput[0].value + '€'
                this.rangeLabel[1].innerHTML = this.priceInput[1].value + '€'
                
                this.rangeLabel[0].style.left = ((this.rangeInput[0].value / this.rangeInput[0].max) * 100) + '%'
                this.rangeLabel[0].style.transform = 'translateX(' + (-1 * ((this.rangeInput[0].value / this.rangeInput[0].max) * 100)) + '%)'
                this.rangeLabel[1].style.right = 100 - (this.rangeInput[1].value / this.rangeInput[1].max) * 100 + '%'
                this.rangeLabel[1].style.transform = 'translateX(' + (100 - (this.rangeInput[1].value / this.rangeInput[1].max) * 100) + '%)'

            })

            // Force dispatch event to prevent inconsistent display
            input.dispatchEvent(new Event('input'))
        })
    }
}